import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'datatables.net';
const DataTableLayout = ({ tableId, ajaxUrl, columns, onPayAgain, traceBtnClick }) => {
  const [loadingTableId, setLoadingTableId] = useState(null);

  useEffect(() => {
    let dataTableInstance;

    const loadScriptAndInitialize = async () => {
      try {
        const module = await import('../../../datatable.js'); // Dynamically import
        const initFunc = module.initializeDataTable || window.initializeDataTable;

        if (typeof initFunc === 'function') {
          dataTableInstance = initFunc({
            selector: `#${tableId}`,
            columns,
            ajaxUrl,
          });
        }

        // ---- handle pay again / onPayAgain funciton target to marketplace-pay-btn class

        $(document).on('click', `#${tableId} .marketplace-pay-btn`, function (e) {
          const marketplaceAccountId = $(this).data("record-id");

          const $btn = $(this);

          // 👇 inline-flex + align-middle lagao
          $btn.html(`
    <span class="d-inline-flex align-items-center">
      <span class="spinner-border spinner-border-sm me-1 align-middle" role="status"></span>
      <span class="align-middle">Processing...</span>
    </span>
  `);

          $btn.prop("disabled", true);

          if (onPayAgain) {
            setLoadingTableId(marketplaceAccountId)
            onPayAgain(e, marketplaceAccountId);
          }
        });


      } catch (error) {
        console.error('Failed to load or initialize datatable.js:', error);
      }
    };

    loadScriptAndInitialize();

    return () => {
      // Clean up on unmount
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy(true);
      }
    };
  }, [tableId, ajaxUrl, columns]);


  useEffect(() => {
    if (!traceBtnClick?.isLoading && traceBtnClick?.btnClickPackageId === null && loadingTableId) {
      // sirf usi button ko reset karo jiska id match kare
      $(`#${tableId} .marketplace-pay-btn[data-record-id="${loadingTableId}"]`)
        .html("Pay Now")
        .prop("disabled", false);
      setLoadingTableId(null)
    }
  }, [traceBtnClick, tableId, loadingTableId]);



  return (<>
    <table id={tableId} className="display">
      <thead>
        <tr>
          {columns.map((col, index) => (
            <th key={index}>{col.title || col.data}</th>
          ))}
        </tr>
      </thead>
    </table>
  </>
  );
};

export default DataTableLayout;
